import "./TeslaInsuranceOffers.module.css";
import Header from "@/reusable_sections/Header";
import WelcomeToTheLight from "./sections/WelcomeToTheLight";
import Funktioner from "./sections/Funktioner";
import Terminalkontakt from "./sections/Terminalkontakt";
import Footer from "@/reusable_sections/Footer";
export default function TeslaInsuranceOffersPage() {
  return <div>
      <Header />
      <WelcomeToTheLight />
      <Funktioner />
      <Terminalkontakt />
      <Footer />
    </div>;
}